import { WMSLegend } from "../legends/WMSLegend";
import LayerGroupSettings from "./LayerGroupSettings";

import { createAOILayer } from "../layers/AOiLayer";

class AOILayerGroup extends LayerGroupSettings {
  constructor(map = null, title, aoi_uuid, type = "") {
    super();
    this.id = "layergroup-aoi";

    this.name = title;
    this.order = 0;
    title = this.name;
    // let title    = "Límites del área de estudio";
    let subtitle = "Delimitación";
    const legend_wms = process.env.REACT_APP_GEOSERVER_URL_WMS;
    const capa_wms_aoi = process.env.REACT_APP_GEOSERVER_LAYER_AOI;
    const base_url = process.env.REACT_APP_GEOSERVER_URL;
    let style = null
    if (type == "municipio" || type === "MUNICIPAL") {
      // title = "Límites administrativos";
      // subtitle = "Municipio";
      style = {
        legend_title: {
          es: "Municipal boundary",
          en: "Municipal boundary",
          pt: "Municipal boundary",
        },
      }
    }
    const aoi_legend = new WMSLegend({
      // base_url + legend_wms,
      geoserver_layer_id: capa_wms_aoi,
      // title,
      
      // subtitle
      style: style,
      rule: "Low Zoom",
    });
    // this.legends = [aoi_legend];
    this.map = map;
    this.selectedFeatures = [];

    this.layer_01 = createAOILayer(
      this.defaultLayer,
      this.onLeftClick,
      this.map,
      aoi_uuid
    );
    this.layer_01.legend = aoi_legend;
    this.layer_01.layer_group_id = this.id;

    this.layers.push(this.layer_01);
  }

  async onLeftClick() {
    return false;
  }
}
export default AOILayerGroup;
